module.exports = __webpack_public_path__ + "f4cbc8201404acce011e410a6b32aefe.svg";